import axios from 'axios'
import store from '@/store/index'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status

    if (status === 401) {
      store.dispatch('auth/logout')
    }

    return Promise.reject(error)
  }
)

export const $axios = axios.create()
